import { styled, keyframes } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const rotate = keyframes`
  0% { 
    transform: rotate(0deg);
  }

  100% { 
    transform: rotate(360deg);
  }
`;

export const StyledButton = styled(Button, {
  shouldForwardProp: prop =>
    prop !== "hasLeftLabel" && prop !== "hasRightLabel",
})<{ hasLeftLabel: boolean; hasRightLabel: boolean }>(props => {
  return {
    display: "flex",
    alignItems: "center",
    maxHeight: "32px",
    borderRadius: "4px",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    "& > svg": {
      fontSize: "16px",
    },
    "& > span": {
      display: "inline-flex",
      justifyContent: "center",
      marginRight: props.hasLeftLabel ? "4px" : "0px",
      marginLeft: props.hasRightLabel ? "4px" : "0px",
    },
  };
});

export const ButtonLoader = styled("div")({
  border: "6px solid #f3f3f3",
  borderRadius: "50%",
  borderTop: "6px solid #3498db",
  width: "6px",
  height: "6px",
  animation: `${rotate} 2s linear infinite`,
  marginLeft: ".5rem",
  marginBottom: "1px",
});
